import { FormattedMessage } from 'react-intl';
import React from 'react';
import { Field } from './';

const EmailField = props => (
  <Field
    type="email"
    name="email"
    data-qa="login-email-field"
    label={
      <FormattedMessage
        id="form.email"
        description="Email field label"
        defaultMessage="Email"
      />
    }
    {...props}
  />
);
export default EmailField;



// WEBPACK FOOTER //
// ./src/components/FormComponents/EmailField.js